export const ENUM = Object.freeze({
  WA_API_TYPE: 'WAApi',
  AGENT_TYPE: 'Agent',
  REGULAR_TYPE: 'RegularUser',
  TIMEOUT: 'TIMEOUT',
  AVAILABLE: 'AVAILABLE',
});
